/* global modForm modUtils Modalytics */
import { heapIdentify, getDefaultQuad, transformQuadlink, getSavedQueryParams, defaultQuadLinkValues, getPhoneAssignmentData, trackPageContextToGA4 } from '../../helpers';

/**
 * function to extract the required values from a quad link
 * @param {boolean} useIdlizeQueueInternally if true it will Idlize the ajaxQuadlinkTransform() call inside this function. Useful when calling `initQuadTransform()` immediately in the `initQSForm()`
 */
export async function initQuadTransform(useIdlizeQueueInternally = false) {
	// We check if there's a quad link on the query string, if not we get the default value
	const currentParams = getSavedQueryParams() || modUtils.getUrlParamsToObject(),
		hasQuadLink = currentParams.hasOwnProperty('quadlink'), // eslint-disable-line no-prototype-builtins
		hastagID = currentParams.hasOwnProperty('tagID'), // eslint-disable-line no-prototype-builtins
		heapMsg = { message: '' },
		hasQsParams = Object.keys(currentParams).some(function(param) {
			return modForm.opts.qsParams.includes(param.toUpperCase());
		});

	// Set all URL params to quadLinkData (skip keys that are already initialized)
	for (const [param, value] of Object.entries(currentParams)) {
		if (!(param in modForm.opts.quadLinkData)) {
			modForm.opts.quadLinkData[param] = value;
		}
	}

	if (hasQsParams) {
		for (const param in currentParams) {
			if (modForm.opts.qsParams.includes(param.toUpperCase()) && typeof currentParams[param] !== 'undefined') {
				modForm.opts.quadLinkParams[param.toUpperCase()] = currentParams[param];
			}
		}

		heapIdentify();

		if (window.geolocation) {
			document.addEventListener('geolocation.dataReady', function() {
				if (modForm.opts.phoneAssignmentConfig.showPhoneAssignmentNumber) {
					getPhoneAssignmentData(modForm.opts.quadLinkParams);
				}
			});
		} else if (modForm.opts.phoneAssignmentConfig.showPhoneAssignmentNumber) {
			getPhoneAssignmentData(modForm.opts.quadLinkParams);
		}

		if (modForm.opts.quadLinkParams && Object.keys(modForm.opts.quadLinkParams).length && modForm.opts.quadLinkParams.CCID) {
			modForm.opts.quadLinkData.CCID = modForm.opts.quadLinkParams.CCID;
			transformQuadlink({ skipPhoneAssignmentCall: true });
		} else {
			trackPageContextToGA4();
		}
	} else {
		let quadLinkUrl = '',
			quadLinkType = '';
		if (hastagID) {
			quadLinkUrl = currentParams.tagID;
			quadLinkType = 'tagID';
		} else {
			quadLinkUrl = hasQuadLink ? currentParams.quadlink : getDefaultQuad(modForm.opts.vertical);
			quadLinkType = hasQuadLink ? 'quadlink' : 'defaultQuad';
		}

		modForm.opts.quadLinkData[quadLinkType] = quadLinkUrl;

		if (quadLinkUrl !== '') {
			// update source used for Best Company Blind Match forms (if user is coming in with existing params)
			if (modUtils.getLandingPage().includes('bestcompany') && modUtils.getLandingPage().includes('find-a-pro')) {
				const quadlinkInput = document.querySelector('input[name="quadlink"]');
				const blindMatchDefaultQuad = getDefaultQuad(defaultQuadLinkValues['bestcompany.com'].findapro);
				const blindMatchQuad = blindMatchDefaultQuad.replace('&default=yes;', '');
				// update quad value being sent through to LeadAnalyzer (so there is no confusion)
				if (quadlinkInput) {
					quadlinkInput.value = blindMatchQuad;
				}
				// transform the quadlink using this blind match specific one
				if (modForm.opts.quadLinkData.quadlink) {
					modForm.opts.quadLinkData.quadlink = blindMatchQuad;
				} else {
					modForm.opts.quadLinkData.defaultQuad = blindMatchQuad;
				}
			}

			if (useIdlizeQueueInternally) {
				if ('IdlizeQueue' in window) {
					heapMsg.message = 'initQuadTransform() called on DOMContentLoaded with IdlizeQueue';
					window.IdlizeQueue.pushTask(() => {
						transformQuadlink();
					});
				} else {
					transformQuadlink();
					heapMsg.message = 'initQuadTransform() called on DOMContentLoaded without IdlizeQueue';
				}
			} else {
				transformQuadlink();
				heapMsg.message = 'initQuadTransform() called on window.onload';
			}
		}
		Modalytics.heap('track', ['Quad Transform', heapMsg]);
	}
}
